import ProductChip from './ProductChip';

export default ProductChip;
